import { Badge } from "reactstrap";
import { generateSongNumbers, generateTags } from "./ResultEntryUtils";
import { nullToUndefined } from "../../../helper/nullToUndefined";
import { getLanguageLabel } from "../../helpers/languageHelpers";
import { SongUb } from "../../../gql/graphql";

export type BadgeProvider = Pick<SongUb, "tags" | "tonality" | "language"> & {
  songnumbers: { mnemonicNumber: string }[];
};

interface Props {
  badgeProvider: BadgeProvider;
}

export function SongBadges({ badgeProvider }: Props) {
  const languageLabel = nullToUndefined(
    badgeProvider.language && getLanguageLabel(badgeProvider.language),
  );

  return (
    <>
      {generateTags(badgeProvider.tags)}
      {languageLabel && (
        <Badge className="bg-info-subtle text-dark me-2">{languageLabel}</Badge>
      )}
      {badgeProvider.tonality && (
        <Badge className="bg-success-subtle text-dark me-2">
          {badgeProvider.tonality}
        </Badge>
      )}
      {generateSongNumbers(
        badgeProvider.songnumbers.map((sn) => sn.mnemonicNumber),
      )}
    </>
  );
}
